import type { StateCreator } from 'zustand';

import type { AITransfersStore } from './useAITransfersStore';

export type BlacklistedPlayer = {
  id: string;
  displayName: string;
  fullName?: string;
  team: string;
  type: 'in' | 'out';
};

export interface BlacklistSlice {
  blacklistedPlayers: BlacklistedPlayer[];
  addBlacklistedPlayer: (entry: BlacklistedPlayer) => void;
  removeBlacklistedPlayer: (id: string, type?: 'in' | 'out') => void;
  clearBlacklist: () => void;
}

export const createBlacklistSlice: StateCreator<
  AITransfersStore,
  [],
  [],
  BlacklistSlice
> = (set) => ({
  blacklistedPlayers: [],
  addBlacklistedPlayer: (entry) =>
    set((state) => {
      const exists = state.blacklistedPlayers.some(
        (p) => p.id === entry.id && p.type === entry.type
      );
      if (exists) return state;
      return {
        blacklistedPlayers: [...state.blacklistedPlayers, entry]
      };
    }),
  removeBlacklistedPlayer: (id, type) =>
    set((state) => ({
      blacklistedPlayers: state.blacklistedPlayers.filter((p) =>
        type ? p.id !== id || p.type !== type : p.id !== id
      )
    })),
  clearBlacklist: () =>
    set({
      blacklistedPlayers: []
    })
});
